export interface ItemProduct {
  product: string;
  description?: string;
  internalid?: string;
}

